import { render } from "./BrandDialogFilter.vue?vue&type=template&id=5ca5d8e6&scoped=true"
import script from "./BrandDialogFilter.vue?vue&type=script&lang=js"
export * from "./BrandDialogFilter.vue?vue&type=script&lang=js"

import "./BrandDialogFilter.vue?vue&type=style&index=0&id=5ca5d8e6&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ca5d8e6"]])

export default __exports__